var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "v-height-flag ml20 mr20",
      staticStyle: { "min-height": "calc(100vh - 200px)" },
    },
    [
      _c(
        "div",
        { directives: [{ name: "height", rawName: "v-height" }] },
        [
          _c("el-alert", {
            staticClass: "cr-alert",
            attrs: {
              "show-icon": "",
              title:
                "「云文件配置」利用WPS平台开放功能实现文档在线预览编辑功能，接入WPS平台服务，获取APPID和APPKEY，填入即可。",
              type: "info",
            },
          }),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "mt20",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "150px",
              },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 14 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "编辑类型：", prop: "wps_type" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.form.wps_type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "wps_type", $$v)
                                },
                                expression: "form.wps_type",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("WPS"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("系统自带"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.form.wps_type == 0
                ? [
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 14 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: { label: "APPID：", prop: "wps_appid" },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: "请输入APPID（从WPS平台申请）",
                                    size: "small",
                                  },
                                  model: {
                                    value: _vm.form.wps_appid,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "wps_appid", $$v)
                                    },
                                    expression: "form.wps_appid",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "ml14 copy-data",
                                attrs: { type: "text" },
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "https://developer.kdocs.cn/",
                                      target: "_blank",
                                    },
                                  },
                                  [_vm._v("进入WPS平台 ")]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 14 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "APPKEY：",
                                  prop: "wps_appkey",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder:
                                      "请输入APPKEY（从WPS平台申请）",
                                    size: "small",
                                  },
                                  model: {
                                    value: _vm.form.wps_appkey,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "wps_appkey", $$v)
                                    },
                                    expression: "form.wps_appkey",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { staticClass: "form-item" },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 14 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: { label: "应用地址：", prop: "address" },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled: true,
                                    placeholder: "请输入网站地址",
                                    size: "small",
                                  },
                                  model: {
                                    value: _vm.form.address,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "address", $$v)
                                    },
                                    expression: "form.address",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "ml14 copy-data",
                                attrs: {
                                  "data-clipboard-text": _vm.form.address,
                                  type: "text",
                                },
                                on: { click: _vm.copy },
                              },
                              [_vm._v("复制地址")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("el-form-item", [
                      _vm._v(
                        "\n          请将应用地址粘贴至 WPS在线平台编辑应用服务 [数据回调地址] 中，操作详情请参考帮助文档\n        "
                      ),
                    ]),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        loading: _vm.loading,
                        size: "small",
                        type: "primary",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm()
                        },
                      },
                    },
                    [_vm._v("立即提交")]
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }